<!-- 予約/購入エラー -->
<template>
  <TemplateMfittBookingMailSentError />
</template>

<script>
import TemplateMfittBookingMailSentError from "@/views/Templates/MFITT/TemplateMfittBookingMailSentError";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingMailSentError",
  components: {
    TemplateMfittBookingMailSentError,
  },
  setup() {},
};
</script>
